import React, { useState } from "react";

interface CertificateProps {
  certificates: any[];
}

const Certificates: React.FC<CertificateProps> = ({ certificates }) => {
  const [showAll, setShowAll] = useState(false);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  const displayedCertificates = showAll ? certificates : certificates.slice(0, 2);

  return (
    <div className="mt-2.5">
      <ul className="gap-1 flex items-center flex-wrap text-xs">
        <li>
          <p className="text-text-quaternary font-semibold">Certificates:</p>
        </li>
        {displayedCertificates.map(item => (
          <li
            key={item.name}
            className="px-2.5 py-0.5 text-[#344054] font-medium border-1 border bodrer-[#D0D5DD] rounded-full cursor-pointer"
          >
            <a href={item.url} target="_blank" rel="noreferrer" >
              {item?.name}
            </a>
          </li>
        ))}
        {/* Show a toggle option if there are more than two certificates */}
        {certificates.length > 2 && (
          <li
            className="px-2.5 py-0.5 text-[#344054] font-medium border-1 border bodrer-[#D0D5DD] rounded-full cursor-pointer"
            onClick={toggleShowAll}
          >
            {showAll ? "Show Less" : `+${certificates.length - 2}`}
          </li>
        )}
      </ul>
    </div>
  );
};

export default Certificates;
